import * as BuyIntentionModels from 'model/BuyIntention';
import { useCallback, useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import * as BuyIntentionCalls from 'store/state/buyIntention/apiCalls';
import { alertActions } from 'store/state/slices';
import * as BuyIntentionSelectors from '../../../store/state/buyIntention/buyIntenteionSelectors';
import { actions as buyIntentionActions } from '../../../store/state/buyIntention/buyIntentionSlice';

export function useBuyIntentionItemActions() {
  const dispatch = useDispatch();

  const deliveryDate = useSelector(BuyIntentionSelectors.getDeliveryDate);
  const businessDate = useSelector(BuyIntentionSelectors.getComercialDate);
  const offersList = useSelector(BuyIntentionSelectors.getOffersList);
  const idSelected = useSelector(BuyIntentionSelectors.getIdSelectedNow);
  const isLoading = useSelector(BuyIntentionSelectors.getIsLoading);
  const showModalOffers = useSelector(BuyIntentionSelectors.getShowModalOffers);
  const currentStep = useSelector(BuyIntentionSelectors.getCurrentStep);
  const reloadOffers = useSelector(BuyIntentionSelectors.getReloadOffers);
  const customer = useSelector(BuyIntentionSelectors.getIntentionCustomer);
  const commercialDateFinish = useSelector(
    BuyIntentionSelectors.getComercialDateFinish,
  );
  const deliveryDateFinish = useSelector(
    BuyIntentionSelectors.getDeliveryDateFinish,
  );

  const [showRegisterConfirmationModal, setShowRegisterConfirmationModal] =
    useState<boolean>(false);
  const [showObservationModal, setShowObservationModal] =
    useState<boolean>(false);
  const [idOffer, setIdOffer] = useState<string | undefined>(undefined);
  const [obsText, setObsText] = useState<string>('');
  const [recordData, setRecordData] = useState<any>(undefined);
  const [showDeleteModal, setShowDeleteModal] = useState<boolean>(false);
  const [nameProduct, setNameProduct] = useState<string>('');
  const [overviewItem, setOverviewItem] = useState<
    BuyIntentionModels.BuyIntentionData | undefined
  >(undefined);

  const changeOfferInput = (value: any, property: string, record: any) => {
    if (record.id) {
      dispatch(
        buyIntentionActions.setPropertyValue({
          value,
          property,
          id: record.id,
        }),
      );
      if (currentStep === 1) {
        dispatch(
          buyIntentionActions.setOverview({
            value,
            property,
            id: record.id,
          }),
        );
      }
      if (!record.productPreference && record.site) {
        dispatch(buyIntentionActions.setIdSelectedNow(record.id));
        dispatch(
          BuyIntentionCalls.fetchPacking({
            siteId: record.site.id,
            productId: record.productId,
          }),
        );
        dispatch(buyIntentionActions.setIsLoading(true));
      }
    }
  };

  const choicePacking = (packingCode: string, offer: any) => {
    const composition = offer.productPreference.find(
      (packing: BuyIntentionModels.Packing) => packing.code === packingCode,
    );
    changeOfferInput(composition, 'packingSelected', offer);
    changeOfferInput(composition.qe, 'quantityPacking', offer);
    changeOfferInput(composition.qpe, 'quantityUnit', offer);

    const totalpriceCalc =
      composition.qpe *
      composition.qe *
      (Number(offer.unitPrice) +
        Number(
          composition.additionalCost === 'S' ? composition.packingCost : 0,
        ) +
        Number(
          offer.shippingFeeFilials !== null
            ? offer.shippingFeeFilials.productShippingValue
            : 0,
        ));

    changeOfferInput(totalpriceCalc, 'totalPrice', offer);
    dispatch(
      buyIntentionActions.setTotalPriceOverview({
        id: offer.id,
        value: totalpriceCalc,
      }),
    );

    dispatch(
      buyIntentionActions.setTotalPriceOffers({
        id: offer.id,
        value: totalpriceCalc,
      }),
    );
    dispatch(
      buyIntentionActions.setTotalPriceOffersAux({
        id: offer.id,
        value: totalpriceCalc,
      }),
    );
    if (currentStep === 1) {
      dispatch(
        buyIntentionActions.setTotalPriceOverview({
          id: offer.id,
          value: totalpriceCalc,
        }),
      );
    }
  };

  const choiceProducer = (producerId: number, record: any) => {
    const producer = record.siteList.find(
      (item: BuyIntentionModels.Producer) => item.id === producerId,
    );
    if (producerId) {
      changeOfferInput(producer, 'site', record);
    } else {
      dispatch(buyIntentionActions.setClearProducerOnTheTable(record.id));
    }
  };

  const dispatchItemTotal = (id: string, totalpriceCalc: number) => {
    dispatch(
      buyIntentionActions.setTotalPriceOffers({
        id,
        value: totalpriceCalc,
      }),
    );
    dispatch(
      buyIntentionActions.setTotalPriceOffersAux({
        id,
        value: totalpriceCalc,
      }),
    );
    if (currentStep === 1) {
      dispatch(
        buyIntentionActions.setTotalPriceOverview({
          id,
          value: totalpriceCalc,
        }),
      );
    }
  };

  const changeQuantityPacking = (
    value_: any,
    _record: BuyIntentionModels.BuyIntentionData,
  ) => {
    if (_record.unitPrice > 0) {
      const price = _record.unitPrice;
      const totalpriceCalc =
        value_ *
        _record.quantityUnit *
        (price +
          (_record.packingSelected.additionalCost === 'S'
            ? _record.packingSelected.packingCost
            : 0) +
          (_record.shippingFeeFilials
            ? _record.shippingFeeFilials.productShippingValue
            : 0));
      changeOfferInput(totalpriceCalc, 'totalPrice', _record);
      dispatchItemTotal(_record.id, totalpriceCalc);
    } else {
      changeOfferInput(0, 'totalPrice', _record);
    }

    changeOfferInput(value_, 'quantityPacking', _record);
  };

  const stepQuantityPacking = (
    value: number,
    _record: BuyIntentionModels.BuyIntentionData,
  ) => {
    if (value % _record.packingSelected?.qe !== 0) {
      changeOfferInput(_record.packingSelected?.qe, 'quantityPacking', _record);
    }
  };

  const changeQuantityUnit = (
    value_: any,
    _record: BuyIntentionModels.BuyIntentionData,
  ) => {
    if (_record.unitPrice > 0) {
      const price = _record.unitPrice;
      const totalpriceCalc =
        value_ *
        _record.quantityPacking *
        (price +
          (_record.packingSelected.additionalCost === 'S'
            ? _record.packingSelected.packingCost
            : 0) +
          (_record.shippingFeeFilials !== null
            ? _record.shippingFeeFilials.productShippingValue
            : 0));
      changeOfferInput(totalpriceCalc, 'totalPrice', _record);
      dispatchItemTotal(_record.id, totalpriceCalc);
    } else {
      changeOfferInput(0, 'totalPrice', _record);
    }

    changeOfferInput(value_, 'quantityUnit', _record);
  };

  const changeUnitPrice = (
    valuePrice: any,
    _record: BuyIntentionModels.BuyIntentionData,
  ) => {
    changeOfferInput(valuePrice, 'unitPrice', _record);
    if (valuePrice > 0) {
      const totalpriceCalc =
        _record.quantityUnit *
        _record.quantityPacking *
        (valuePrice +
          (_record.packingSelected?.additionalCost === 'S'
            ? _record.packingSelected?.packingCost
            : 0) +
          (_record.shippingFeeFilials !== null
            ? _record.shippingFeeFilials.productShippingValue
            : 0));
      changeOfferInput(totalpriceCalc, 'totalPrice', _record);
      changeOfferInput(valuePrice, 'unitPriceNumber', _record);
      dispatchItemTotal(_record.id, totalpriceCalc);
    } else {
      changeOfferInput(0, 'totalPrice', _record);
    }
  };

  const showOffers = () => {
    dispatch(buyIntentionActions.setShowModalOffers(true));
    setShowRegisterConfirmationModal(false);
  };

  const addIntention = () => {
    setShowRegisterConfirmationModal(false);
    if (overviewItem) {
      dispatch(buyIntentionActions.setOverviewTable(overviewItem));
    }
    dispatch(
      buyIntentionActions.setPropertyValue({
        value: true,
        property: 'intention',
        id: idOffer,
      }),
    );
  };

  const warn = (message: string) =>
    dispatch(
      alertActions.alertRequest({
        message,
        type: 'warning',
        showIcon: true,
        timeout: 3000,
      }),
    );

  const validateItem = (record: BuyIntentionModels.BuyIntentionData) => {
    let validator = 0;
    if (!deliveryDateFinish || deliveryDateFinish === '') {
      validator += 1;
      warn('É obrigatório informar a data de entrega');
    }
    if (!commercialDateFinish || commercialDateFinish === '') {
      validator += 1;
      warn('É obrigatório informar a data comercial');
    }
    if (!record.site || record.site === null) {
      validator += 1;
      warn('É obrigatório informar o Produtor');
    }
    if (!record.qualitySelect || record.qualitySelect === '') {
      validator += 1;
      warn('É obrigatório informar a Qualidade');
    }
    if (!record.quantityPacking || record.quantityPacking === 0) {
      validator += 1;
      warn('É obrigatório informar o QE');
    }
    if (!record.quantityUnit || record.quantityUnit === 0) {
      validator += 1;
      warn('É obrigatório informar o QpE');
    }
    if (!record.unitPrice || record.unitPrice === 0) {
      validator += 1;
      warn('É obrigatório informar o valor do produto');
    }
    return validator === 0;
  };

  const searchOffers = (
    record: BuyIntentionModels.BuyIntentionData,
  ): boolean => {
    if (validateItem(record) && !record.bought && !record.intention) {
      setOverviewItem(record);
      dispatch(buyIntentionActions.setIdProductAdded(record.id));
      dispatch(buyIntentionActions.setSubPriceAdded(record.totalPrice));
      dispatch(
        BuyIntentionCalls.fetchOffersList({
          offerTypes: ['onSite', 'directed'],
          productsIds: [record.productId],
          producerIds: [record.site?.producerId],
          qualities: [record.qualitySelect === 'A1' ? 1 : 2],
          deliveryDate,
          businessDate,
          customerId: customer?.id,
        }),
      );
      dispatch(buyIntentionActions.setIdSelectedNow(record.id));
      dispatch(buyIntentionActions.setIsLoading(true));
      setIdOffer(record.id);
      return true;
    }
    return false;
  };

  const saveIntention = (
    record: BuyIntentionModels.BuyIntentionData,
  ): boolean => {
    if (!validateItem(record)) return false;
    dispatch(buyIntentionActions.setOverviewItem(record));
    return true;
  };

  const handleTotalPrice = useCallback(
    (record: BuyIntentionModels.BuyIntentionData) => {
      const QeXQpe = record.quantityUnit * record.quantityPacking;
      if (record.shippingFeeFilials?.productShippingValue) {
        if (record.packingSelected?.additionalCost === 'S') {
          return (
            (record.unitPrice +
              record.shippingFeeFilials?.productShippingValue +
              record.packingSelected.packingCost) *
            QeXQpe
          );
        }

        return (
          (record.unitPrice + record.shippingFeeFilials?.productShippingValue) *
          QeXQpe
        );
      }
      if (record.packingSelected?.additionalCost === 'S') {
        return (record.unitPrice + record.packingSelected.packingCost) * QeXQpe;
      }
      return record.unitPrice * QeXQpe;
    },
    [],
  );

  const openObservation = (observation: string, record: any) => {
    setShowObservationModal(true);
    setObsText(observation);
    setRecordData(record);
  };

  const requestDelete = (record: BuyIntentionModels.BuyIntentionData) => {
    setShowDeleteModal(true);
    setNameProduct(record.productName);
    setIdOffer(record.id);
  };

  const confirmDelete = () => {
    dispatch(buyIntentionActions.setDeleteOffer(idOffer ?? ''));
    setShowDeleteModal(false);
  };

  const cancelDelete = () => setShowDeleteModal(false);

  const closeOffersModal = () =>
    dispatch(buyIntentionActions.setShowModalOffers(false));

  useEffect(() => {
    if (reloadOffers) {
      if (offersList.length && idSelected === idOffer) {
        setShowRegisterConfirmationModal(true);
      }
      if (offersList.length === 0 || !offersList) {
        if (idOffer) {
          dispatch(
            buyIntentionActions.setPropertyValue({
              value: true,
              property: 'intention',
              id: idOffer,
            }),
          );
          if (overviewItem) {
            dispatch(buyIntentionActions.setOverviewTable(overviewItem));
          }
        }
      }
      dispatch(buyIntentionActions.setReloadOffers(false));
    }
  }, [offersList, reloadOffers]);

  return {
    currentStep,
    customer,
    isLoading,
    showModalOffers,
    changeOfferInput,
    choicePacking,
    choiceProducer,
    changeQuantityPacking,
    stepQuantityPacking,
    changeQuantityUnit,
    changeUnitPrice,
    searchOffers,
    saveIntention,
    handleTotalPrice,
    showRegisterConfirmationModal,
    showOffers,
    addIntention,
    showObservationModal,
    setShowObservationModal,
    obsText,
    recordData,
    openObservation,
    showDeleteModal,
    nameProduct,
    requestDelete,
    confirmDelete,
    cancelDelete,
    closeOffersModal,
  };
}

export type BuyIntentionItemActions = ReturnType<
  typeof useBuyIntentionItemActions
>;
